module.exports = __webpack_public_path__ + "static/img/title.97e3bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/role/character_1/title.png
// module id = k83W
// module chunks = 1